import EventDispatcher from "../event-dispatcher";

export class CommandManager extends EventDispatcher {

    channel: string;

    constructor(channel: string) {
        super();

        this.channel = channel;

        window.addEventListener(`command-manager-${this.channel}`, (event: CustomEvent) => {
            const { action, args } = event.detail;
            this.trigger(action, ...args);
        });
    }

    static do(channel: string, action: string, ...args: unknown[]) {
        window.dispatchEvent(new CustomEvent(
            `command-manager-${channel}`, { detail: { action, args: args }}));
    }
}
export default CommandManager;
